import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import ChatWidget from '@/components/agent-chat/components/chat-widget';
import { ChatWidgetSlotProvider } from '@/components/agent-chat/components/chat-widget/chat-widget-slot-context';
import { InvestigationScopeProvider } from '@/components/agent-chat/components/chat-widget/investigation-scope-context';
import RunCompletionWatcher from '@/components/agent-chat/components/run-completion-watcher';
import useChatWidgetEnabled from '@/components/agent-chat/hooks/use-chat-widget-enabled';
import { ResourceContextProvider } from '@/components/agent-chat/hooks/use-resource-context-selection';
import BlankLayout from './components/blank-layout';
import DefaultLayout from './components/default-layout';
import FullLayout from './components/full-layout/full-layout';
type PrivateLayoutProps = {
  children: React.ReactNode;
  name: string;
};
const renderBody = (name: string, children: React.ReactNode) => {
  if (name === 'full') return <FullLayout>{children}</FullLayout>;
  if (name === 'blank') return <BlankLayout>{children}</BlankLayout>;
  return <DefaultLayout>{children}</DefaultLayout>;
};
const PrivateLayout = t0 => {
  const $ = _c(10);
  const {
    children,
    name
  } = t0;
  const isChatEnabled = useChatWidgetEnabled();
  let t1;
  if ($[0] !== children || $[1] !== name) {
    t1 = renderBody(name, children);
    $[0] = children;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChatWidget />;
    t3 = <RunCompletionWatcher />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1) {
    t4 = <ChatWidgetSlotProvider>{t1}{t2}{t3}</ChatWidgetSlotProvider>;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isChatEnabled || $[8] !== t4) {
    t5 = <InvestigationScopeProvider><ResourceContextProvider enabled={isChatEnabled}>{t4}</ResourceContextProvider></InvestigationScopeProvider>;
    $[7] = isChatEnabled;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default PrivateLayout;